module.exports = __webpack_public_path__ + "static/weekWorkHour-bg.d25120bc.png";